let NumberPad = require("../../templates/NumberPad.handlebars");
let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import NumberPadView from "../comp/NumberPadView.js";
import POS from "../../POS.js";

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .discount": "_chooseDiscount",
            "click .btn.btn-all": "_showAllDiscounts",
            "click .btn.btn-ratio": "_showRatioDiscounts",
            "click .btn.btn-amount": "_showAmountDiscounts",
            "click .btn.ignore": "_chooseIgnore",
            'click .btn.tip': '_chooseTip',
            "click .btn.confirm-ignore": "_adjustmentAmount",
            "mousedown .discount": "_addDownStyle",
            "mouseup .discount": "_removeDownStyle",
            "click .discount-switcher .btn-group .btn": "_addSwitchDiscountStyle",
            "click .passwordEntry .confirm" : '_checkPassword',
            "click .passwordEntry .cancel" : '_cancelCheckPassword'
        },
        initialize: function () {
            var self = this, numberPadView = $(NumberPad({}));
            self.$(".numberpad-container").prepend(numberPadView);
            self.numberpad = new NumberPadView({el: numberPadView, model: new Backbone.Model({type: "mutual"})});
            self.numberpad.changeTarget(self.$(".btn.ignore"));
        },
        _showAllDiscounts: function () {
            var self = this;
            self._toggleDistricts("discounts");
            self.$(".discounts .discount").removeClass("hidden");
        },
        _showAmountDiscounts: function () {
            var self = this;
            self._toggleDistricts("discounts");
            self.$(".discounts .discount").addClass("hidden");
            self.$(".discounts .discount[data-type=Amount]").removeClass("hidden");
        },
        _showRatioDiscounts: function () {
            var self = this;
            self._toggleDistricts("discounts");
            self.$(".discounts .discount").addClass("hidden");
            self.$(".discounts .discount[data-type=Percentage]").removeClass("hidden");
        },
        _chooseDiscount: function (event) {
            var self = this, discount = $(event.currentTarget);
            if(discount.data('approval') && !POS.getUser().isAdmin) {
                var parent = discount.closest('.discount-selector');
                parent.children().not('.passwordEntry').addClass('hidden');
                parent.find('.passwordEntry').removeClass('hidden').find('.error').text('');
                self.model.set('selectedDiscountId', discount.data('id'));

            } else {
                self.model.unset("discountId");
                self.model.set({discountId: discount.data("id"), discount: discount.data()});
                if ($('.cashier-print .cashierAmount .amountTitle-discount').hasClass("hidden")) {
                    $('.cashier-print .cashierAmount .amountTitle-discount').removeClass('hidden');
                }
            }
        },
        _adjustmentAmount: function () {
            var self = this;
//                self.numberpad.remove();
            if (self.numberpad.target.hasClass('tip')) {
                self.model.unset('usetip');
                self.model.set({usetip: true, tipAmount: parseFloat(self.numberpad.model.get("numberInput"))});
            } else {
                self.model.unset('useignore');
                self.model.set({useignore: true, ignoreAmount: parseFloat(self.numberpad.model.get("numberInput"))});
            }
        },
        _chooseIgnore: function (evt) {
            var self = this;
            self._toggleDistricts('numberpad-container');
            self.numberpad.changeTarget($(evt.currentTarget));
        },
        _chooseTip: function (evt) {
            var self = this;
            self._toggleDistricts('numberpad-container');
            self.numberpad.changeTarget($(evt.currentTarget));
        },
        _toggleDistricts: function (target) {
            var self = this;
            self.$(".district").addClass("hidden");
            self.$(".district." + target).removeClass("hidden");
        },
        _addDownStyle: function (evt) {
            var target = $(evt.currentTarget);
            if (!target.hasClass("discountChoose")) {
                target.addClass("discountChoose");
            }
        },
        _removeDownStyle: function (evt) {
            var target = $(evt.currentTarget);
            if (target.hasClass("discountChoose")) {
                target.removeClass("discountChoose");
            }
        },
        _addSwitchDiscountStyle: function (evt) {
            var target = $(evt.currentTarget);
            var buttons = $(evt.currentTarget).siblings();
            buttons.each(function (n, button) {
                if ($(button).hasClass("selected")) {
                    $(button).removeClass("selected")
                }
            });
            if (!target.hasClass("selected")) {
                target.addClass("selected");
            }
        },
        _checkPassword: function() {
            var discountId = this.model.get('selectedDiscountId');
            var self = this, result = $.post('/pos/checkPwd',
                {username: this.$('.adminSelect option:selected').text(), password: this.$('.passwordEntry input[type="password"]').val()});

            result.done(function(res) {
               console.log('result', res);
                if(res.success) {
                    if(discountId) {
                        self.model.unset("discountId");
                        self.model.set({discountId: discountId, discount: self.$('discount [data-id="' + discountId + '"]').data()});
                        self.$('.passwordEntry').addClass('hidden');
                        self.$('.passwordEntry input').val("");

                        if ($('.cashier-print .cashierAmount .amountTitle-discount').hasClass("hidden")) {
                            $('.cashier-print .cashierAmount .amountTitle-discount').removeClass('hidden');
                        }
                    } else {
                        alert(window.g_i18n['pos.serverError']);
                    }

                } else {
                    self.$('.passwordEntry .error').text(window.g_i18n['pos.cashier.invalidAuthentication']);
                }
            });

            result.fail(function(res) {
                console.log('result', res);
                alert(window.g_i18n['pos.serverError']);
            });

        },
        _cancelCheckPassword: function() {
            this.$el.children().not('.passwordEntry,.numberpad-container,.use-error').removeClass('hidden');
            this.$('.passwordEntry').addClass('hidden');
        }
    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/cashier/DiscountSelectorView.js